import WhatsAppService, {
  whatsappTransfer,
  whatsappQualify,
  activeJobWhatsapp,
  whatsappReopen,
  sendWhatsAppVoiceCallPermission,
} from '@/services/whatsapp-service';
import { getMessageById } from '@/services/whatsapp-messages-service';
import { formatMessagesJob } from '@/shared/utils/job-helpers';
import { selectContactByLatestInteraction } from '@/shared/utils/contact-helpers';
import JobService from '@/services/job-service';
import { getTagsByProtocol } from '@/services/tag-service';
import ContactService from '@/services/contact-service';
import { getGroups } from '@/services/attendance-groups-service';
import router from '@/router';
import {
  ADD_NEW_JOB,
  NEW_MANUAL_ACTIVATION,
  SAVE_UNATTENDED_MESSAGE,
  DELETE_UNATTENDED_MESSAGES,
  WHATSAPP_NUMBER_NOT_EXISTS,
  ADD_ATTENDANCE_JOB,
} from '@/store/mutation-types';
import { handleError } from '@/shared/utils/promise-helpers';
import { EventBus } from '@/event-bus';
import { isFeatureEnabled } from '@/plugins/featureFlag';

const actions = {
  async addNewJob({ commit, dispatch, getters, rootGetters, rootState }, job) {
    job.messages = [];
    const hasProtocolAttendance = job.hasProtocolAttendance || false;
    if (hasProtocolAttendance) delete job.hasProtocolAttendance;

    try {
      if (job.hasOwnProperty('protocolInbox')) {
        job.notifications = getters.inboxMessagesAmount(job.protocolInbox);
      }
      const routeWhatsAppDestination = job.from.split('@')[1];

      const agentId = rootGetters['attendance/attendance'].agentId;
      const org_unit_id = rootGetters['attendance/attendance'].org_unit_id;

      let jobIdentifier = '';
      let jobIdentifierField = '';

      if (job?.metaType === undefined) {
        jobIdentifier = job.contactIdentifier;
        jobIdentifierField = 'whatsapp_identifier';
      } else {
        jobIdentifier =
          job?.metaType.toLowerCase() == 'whatsapp'
            ? job.contactIdentifier
            : job.customFields?.contact_username;
        jobIdentifierField =
          job?.metaType.toLowerCase() == 'whatsapp'
            ? 'whatsapp_identifier'
            : 'instagram_username';
      }

      const [
        contacts,
        queue,
        campaign,
        routesCampaign,
        routesQueue,
        historyMessages,
        tagsAttendance,
        groups,
      ] = await Promise.all([
        job.contactId
          ? ContactService.getById(job.contactId)
          : ContactService.getByIdentifier(
              jobIdentifier,
              jobIdentifierField,
              agentId,
              true,
            ),
        WhatsAppService.getQueueWhatsAppById(job.whatsAppQueue),
        WhatsAppService.getCampaignWhatsAppById(job.whatsAppCampaign),
        WhatsAppService.getWhatsappRoutesCampaign(job.whatsAppCampaign),
        WhatsAppService.getWhatsappRoutesQueue(job.from),
        dispatch(
          'contact/getMessageHistory',
          {
            ...job,
            ...job.paramsHistoryMessages,
            mustNot: job.protocol,
            org_unit_id,
            attendanceType: job.attendanceType,
            route: routeWhatsAppDestination,
          },
          { root: true },
        ),
        getTagsByProtocol(job.protocol),
        getGroups(agentId),
      ]);

      const attendanceGroupInfo = groups.find(
        (group) => group.id == job.attendanceGroupId,
      );
      const observationRequired = attendanceGroupInfo
        ? attendanceGroupInfo.observation_required
        : false;
      job.attendanceGroupInfo = { observationRequired };

      let route = [];
      if (routesCampaign.data == null) route = routesQueue;
      else route = routesCampaign;

      let infobipTemplates;
      let zenviaTemplates;
      let gupshupTemplates;
      let templatesMess;
      let historyMessagesDb;

      let searchLastMessageDb = false;

      if (
        job.lastMessageId &&
        job.lastMessageId != '' &&
        (!job.transfer || job.transfer == false) &&
        (!job.protocolInbox || job.protocolInbox == '')
      ) {
        searchLastMessageDb = true;
      } else {
        job.lastMessageId = '';
      }

      job.searchLastMessageDb = searchLastMessageDb;
      job.org_unit_id = org_unit_id;

      historyMessagesDb = await Promise.all([
        dispatch(
          'contact/getMessageHistoryDb',
          { contactIdentifier: job.contactIdentifier, protocol: job.protocol },
          { root: true },
        ),
      ]);

      if (route.data && route.data[0].api == 'infobip') {
        let codapiaux = route.data[0].api_url.split('/');
        const params = {
          sender: route.data[0].phonenumber,
          hash: route.data[0].apikey,
          codapi: codapiaux[2],
        };

        infobipTemplates = await Promise.all([
          WhatsAppService.getInfobipWhatsappTemplatesMessages(params),
        ]);
      } else if (route.data && route.data[0].api == 'zenvia') {
        zenviaTemplates = await Promise.all([
          WhatsAppService.getZenviaWhatsappTemplatesMessages(),
        ]);
      } else if (route.data && route.data[0].api == 'gupshup') {
        if (isFeatureEnabled('getWhatsappTemplatesByGroup')) {
          gupshupTemplates = await Promise.all([
            WhatsAppService.getGupshupWhatsappTemplatesMessagesByGroup(
              job.attendanceGroupId,
            ),
          ]);
        } else {
          gupshupTemplates = await Promise.all([
            WhatsAppService.getGupshupWhatsappTemplatesMessages(
              org_unit_id,
              route.data[0].id,
            ),
          ]);
        }
      } else if (route.data && route.data[0].api == 'twilio') {
        templatesMess = await Promise.all([
          WhatsAppService.getWhatsappTemplatesMessages(job.whatsAppCampaign),
        ]);
      }

      let contactSelected = null;
      if (contacts.data.length > 1) {
        contactSelected = await selectContactByLatestInteraction(
          contacts.data,
          job.contactIdentifier,
          'whatsapp',
          routeWhatsAppDestination,
        );
      } else {
        contactSelected = contacts.data;
      }

      job.contact = await dispatch('defaultContact', {
        contacts: contactSelected,
        protocol: job.protocol,
      });
      job.queue = queue.data;
      job.campaign = campaign.data;
      job.tags = tagsAttendance;

      job.api = job.routeApi;

      if (job.contactIdentifier.charAt(0) == '+')
        job.contactIdentifier = job.contactIdentifier.substring(1);
      if (job.from.charAt(0) == '+') job.from = job.from.substring(1);

      job.templatesMessages = null;
      if (route.data && route.data[0].api == 'infobip') {
        job.templatesMessages =
          infobipTemplates[0].data !== null
            ? infobipTemplates[0].data.templates
            : null;
      } else if (route.data && route.data[0].api == 'twilio') {
        job.templatesMessages =
          templatesMess[0].data !== null ? templatesMess[0].data.body : null;
      } else if (route.data && route.data[0].api == 'zenvia') {
        job.templatesMessages =
          zenviaTemplates[0].data !== null
            ? zenviaTemplates[0].data.body
            : null;
      } else if (route.data && route.data[0].api == 'gupshup') {
        const params = {
          identifier: job.contactIdentifier,
          srcname: route.data[0].srcname_gupshup,
          token: route.data[0].apikey,
        };

        dispatch('setGupshupUserOptin', params);
        job.templatesMessages =
          gupshupTemplates[0].data !== null ? gupshupTemplates[0].data : null;
      }

      job.routeWhatsapp = route.data !== null ? route.data[0] : null;

      var formatedMessagesDb = '';

      if (historyMessages) {
        historyMessagesDb = historyMessagesDb ? historyMessagesDb[0] : null;
        const formatedMessages = formatMessagesJob(
          historyMessages,
          job,
          agentId,
          true,
        );
        formatedMessagesDb = formatMessagesJob(
          historyMessagesDb,
          job,
          agentId,
          true,
        );

        // Mensagens recebidas enquanto job não estava ativo
        const unattendedMessages = getters.unattendedMessages(job.protocol);

        const messagesDbList = formatedMessagesDb.map((message) =>
          Number(message.message_id),
        );

        let formatUnattendedMessages = unattendedMessages.filter(
          (message) => !messagesDbList.includes(Number(message.message_id)),
        );

        let messagesInOrder = [
          ...formatedMessagesDb,
          ...formatUnattendedMessages,
        ].sort(function (a, b) {
          return Number(a.message_id) - Number(b.message_id);
        });

        if (job.attendanceType != 'MANUAL' && searchLastMessageDb) {
          job.messages = [...formatedMessages, ...messagesInOrder];
        } else {
          job.messages = [...formatedMessages, ...messagesInOrder];
        }

        commit(DELETE_UNATTENDED_MESSAGES, job.protocol);
      } else {
        formatedMessagesDb = formatMessagesJob(
          historyMessagesDb,
          job,
          agentId,
          true,
        );
        if (job.attendanceType != 'MANUAL') {
          job.messages = [...formatedMessagesDb];
        } else {
          job.messages = [];
        }
      }

      job.timestampLastMessage = 0;
      console.log('formatedMessagesDb', formatedMessagesDb);
      if (formatedMessagesDb.length > 0 && job.attendanceType != 'MANUAL') {
        let auxjobMessages = [...formatedMessagesDb];
        let foundMessageDB = false;

        for (let msg of auxjobMessages.reverse()) {
          if (msg.type == 'receipt') {
            foundMessageDB = true;
            let datum = Date.parse(msg.time);
            job.timestampLastMessage = datum / 1000;
            break;
          }
        }

        if (!foundMessageDB) {
          if (job.messages) {
            let auxjobMessages = [...job.messages];
            for (let msg of auxjobMessages.reverse()) {
              if (msg.type == 'receipt') {
                console.log('msg ELASTIC !foundMessageDB', msg);
                let datum = Date.parse(msg.time);
                job.timestampLastMessage = datum / 1000;
                break;
              }
            }
          }
        }
      } else {
        if (job.messages) {
          let auxjobMessages = [...job.messages];
          for (let msg of auxjobMessages.reverse()) {
            if (msg.type == 'receipt') {
              console.log('msg ELASTIC job.messages', msg);
              console.log('receipt janela', msg);
              let datum = Date.parse(msg.time);
              job.timestampLastMessage = datum / 1000;
              break;
            }
          }
        }
      }

      let now = new Date().getTime() / 1000;

      job.startConversation = true;
      job.waitingAnswer = false;

      job.error = false;

      let goToValidation24h = false;

      if (route.data && route.data[0].api_oficial == 'N') {
        goToValidation24h = false;
      } else {
        if (now > job.timestampLastMessage + 86400) {
          goToValidation24h = true;
        } else {
          if (
            (job.attendanceType == 'MANUAL' &&
              job.inboxRemovedByAgent &&
              job.protocolInbox) ||
            (job.attendanceType == 'MANUAL' &&
              job.inboxRemovedByAgent &&
              !job.protocolInbox) ||
            (job.attendanceType == 'MANUAL' &&
              !job.inboxRemovedByAgent &&
              !job.protocolInbox) ||
            (job.attendanceType == 'QUEUE' &&
              job.inboxRemovedByAgent &&
              job.protocolInbox) ||
            (job.attendanceType == 'QUEUE' &&
              job.inboxRemovedByAgent &&
              !job.protocolInbox)
          ) {
            goToValidation24h = true;
          } else {
            goToValidation24h = false;
          }
        }
      }

      if (job.metaType === 'instagram') {
        goToValidation24h = true;
      }

      if (goToValidation24h) {
        if (now > job.timestampLastMessage + 86400) {
          if (job.metaType === 'instagram') {
            job.startConversation = true;
            job.waitingAnswer = true;
            job.allowConversationWithoutTemplate = false;
          } else if (
            (route.data && route.data[0].api == 'twilio') ||
            (route.data && route.data[0].api == 'zenvia') ||
            (route.data && route.data[0].api == 'infobip') ||
            (route.data && route.data[0].api == 'gupshup')
          ) {
            job.startConversation = true;
            job.waitingAnswer = true;
          } else {
            job.startConversation = false;
            job.waitingAnswer = false;
            job.allowConversationWithoutTemplate = true;
          }
        } else {
          job.waitingAnswer = false;
          job.startConversation = false;
          job.allowConversationWithoutTemplate = true;
        }
      } else {
        job.waitingAnswer = false;
        job.startConversation = false;
        job.allowConversationWithoutTemplate = true;
      }

      if (job.startConversation) {
        // dispatch('disableConversationTab')
        dispatch('disableConversationOptions');
      } else {
        dispatch('enableConversationOptions');
      }

      if (job.messages) {
        let auxjobMessages = [...job.messages];
        for (let msg of auxjobMessages.reverse()) {
          if (msg.constructor.name == 'Object') {
            if (msg.type == 'text') {
              job.notifications += 1;
            }
          } else {
            break;
          }
        }
      }

      job.messages.sort((a, b) => new Date(a.time) - new Date(b.time));

      const lastMess = job.messages[job.messages.length - 1];
      if (!lastMess) {
        job.lastMessage = '';
      } else {
        try {
          job.lastMessage = `${JSON.parse(lastMess.message)}` || '';
        } catch (error) {
          job.lastMessage = `${lastMess.message}` || '';
        }
      }

      await commit(ADD_NEW_JOB, job);

      if (!Array.isArray(contacts))
        dispatch('contact/lastContact', job, { root: true });

      if (!job.closedWithoutQualify) {
        if (
          rootState.channel.channels.whatsapp.status == 'paused' ||
          rootState.channel.channels.whatsapp.status == 'scheduled_pause'
        ) {
          dispatch('channel/updateStatusWhatsApp', 'scheduled_pause', {
            root: true,
          });
        } else {
          dispatch('channel/updateStatusWhatsApp', 'in_attendance', {
            root: true,
          });
        }
      }

      dispatch('addHistoryMessages', {
        messages: null,
        protocol: job.protocol,
      });
      if (job.attendanceType != 'MANUAL' && job.metaType !== 'instagram') {
        dispatch(
          'showSnackbar',
          { text: 'newWhatsappJob', type: 'success', browserNotify: true },
          { root: true },
        );
      }

      if (job.attendanceType != 'MANUAL' && job.metaType === 'instagram') {
        dispatch(
          'showSnackbar',
          { text: 'newInstagramJob', type: 'success', browserNotify: true },
          { root: true },
        );
      }

      EventBus.$emit('new-whatsapp-message-sound');

      if (!job.hasOwnProperty('protocolInbox') && !hasProtocolAttendance) {
        dispatch('navigation', job);
      }

      if (
        job.hasOwnProperty('protocolInbox') &&
        job.inboxRemovedByAgent &&
        !hasProtocolAttendance
      ) {
        dispatch('navigation', job);
      }

      const { jobList } = rootState.jobs;
      if (jobList.length == 1 && !hasProtocolAttendance) {
        router.push(`/attendance/${job.protocol}`);
      }
    } catch (err) {
      window.console.error(err);
      dispatch(
        'showSnackbar',
        {
          text: 'Ocorreu um erro ao recuperar os dados do contato',
          type: 'error',
        },
        { root: true },
      );
    }
  },

  async addNewJobWatsapp(
    { commit, dispatch, getters, rootGetters, rootState },
    job,
  ) {
    job.messages = [];
    const hasProtocolAttendance = job.hasProtocolAttendance || false;
    if (hasProtocolAttendance) delete job.hasProtocolAttendance;

    try {
      if (job.hasOwnProperty('protocolInbox')) {
        job.notifications = getters.inboxMessagesAmount(job.protocolInbox);
      }
      const routeWhatsAppDestination = job.from.split('@')[1];

      const agentId = rootGetters['attendance/attendance'].agentId;
      const org_unit_id = rootGetters['attendance/attendance'].org_unit_id;

      const [
        queue,
        campaign,
        routesCampaign,
        routesQueue,
        historyMessages,
        tagsAttendance,
        groups,
      ] = await Promise.all([
        WhatsAppService.getQueueWhatsAppById(job.whatsAppQueue),
        WhatsAppService.getCampaignWhatsAppById(job.whatsAppCampaign),
        WhatsAppService.getWhatsappRoutesCampaign(job.whatsAppCampaign),
        WhatsAppService.getWhatsappRoutesQueue(job.from),
        dispatch(
          'contact/getMessageHistory',
          {
            ...job,
            ...job.paramsHistoryMessages,
            mustNot: job.protocol,
            org_unit_id,
            attendanceType: job.attendanceType,
            route: routeWhatsAppDestination,
          },
          { root: true },
        ),
        getTagsByProtocol(job.protocol),
        getGroups(agentId),
      ]);

      const attendanceGroupInfo = groups.find(
        (group) => group.id == job.attendanceGroupId,
      );
      const observationRequired = attendanceGroupInfo
        ? attendanceGroupInfo.observation_required
        : false;
      job.attendanceGroupInfo = { observationRequired };

      let route = [];
      if (routesCampaign.data == null) route = routesQueue;
      else route = routesCampaign;

      let infobipTemplates;
      let zenviaTemplates;
      let gupshupTemplates;
      let templatesMess;
      let historyMessagesDb;

      let searchLastMessageDb = false;

      if (
        job.lastMessageId &&
        job.lastMessageId != '' &&
        (!job.transfer || job.transfer == false) &&
        (!job.protocolInbox || job.protocolInbox == '')
      ) {
        searchLastMessageDb = true;
      } else {
        job.lastMessageId = '';
      }

      job.searchLastMessageDb = searchLastMessageDb;
      job.org_unit_id = org_unit_id;

      historyMessagesDb = await Promise.all([
        dispatch(
          'contact/getMessageHistoryDb',
          { contactIdentifier: job.contactIdentifier, protocol: job.protocol },
          { root: true },
        ),
      ]);

      if (route.data && route.data[0].api == 'infobip') {
        let codapiaux = route.data[0].api_url.split('/');
        const params = {
          sender: route.data[0].phonenumber,
          hash: route.data[0].apikey,
          codapi: codapiaux[2],
        };

        infobipTemplates = await Promise.all([
          WhatsAppService.getInfobipWhatsappTemplatesMessages(params),
        ]);
      } else if (route.data && route.data[0].api == 'zenvia') {
        zenviaTemplates = await Promise.all([
          WhatsAppService.getZenviaWhatsappTemplatesMessages(),
        ]);
      } else if (route.data && route.data[0].api == 'gupshup') {
        if (isFeatureEnabled('getWhatsappTemplatesByGroup')) {
          gupshupTemplates = await Promise.all([
            WhatsAppService.getGupshupWhatsappTemplatesMessagesByGroup(
              job.attendanceGroupId,
            ),
          ]);
        } else {
          gupshupTemplates = await Promise.all([
            WhatsAppService.getGupshupWhatsappTemplatesMessages(
              org_unit_id,
              route.data[0].id,
            ),
          ]);
        }
      } else if (route.data && route.data[0].api == 'twilio') {
        templatesMess = await Promise.all([
          WhatsAppService.getWhatsappTemplatesMessages(job.whatsAppCampaign),
        ]);
      }
      job.queue = queue.data;
      job.campaign = campaign.data;
      job.tags = tagsAttendance;

      job.api = job.routeApi;

      if (job.contactIdentifier.charAt(0) == '+')
        job.contactIdentifier = job.contactIdentifier.substring(1);
      if (job.from.charAt(0) == '+') job.from = job.from.substring(1);

      job.templatesMessages = null;
      if (route.data && route.data[0].api == 'infobip') {
        job.templatesMessages =
          infobipTemplates[0].data !== null
            ? infobipTemplates[0].data.templates
            : null;
      } else if (route.data && route.data[0].api == 'twilio') {
        job.templatesMessages =
          templatesMess[0].data !== null ? templatesMess[0].data.body : null;
      } else if (route.data && route.data[0].api == 'zenvia') {
        job.templatesMessages =
          zenviaTemplates[0].data !== null
            ? zenviaTemplates[0].data.body
            : null;
      } else if (route.data && route.data[0].api == 'gupshup') {
        const params = {
          identifier: job.contactIdentifier,
          srcname: route.data[0].srcname_gupshup,
          token: route.data[0].apikey,
        };

        dispatch('setGupshupUserOptin', params);
        job.templatesMessages =
          gupshupTemplates[0].data !== null ? gupshupTemplates[0].data : null;
      }

      job.routeWhatsapp = route.data !== null ? route.data[0] : null;

      var formatedMessagesDb = '';

      if (historyMessages) {
        historyMessagesDb = historyMessagesDb ? historyMessagesDb[0] : null;
        const formatedMessages = formatMessagesJob(
          historyMessages,
          job,
          agentId,
          true,
        );
        formatedMessagesDb = formatMessagesJob(
          historyMessagesDb,
          job,
          agentId,
          true,
        );

        // Mensagens recebidas enquanto job não estava ativo
        const unattendedMessages = getters.unattendedMessages(job.protocol);

        const messagesDbList = formatedMessagesDb.map((message) =>
          Number(message.message_id),
        );

        let formatUnattendedMessages = unattendedMessages.filter(
          (message) => !messagesDbList.includes(Number(message.message_id)),
        );

        let messagesInOrder = [
          ...formatedMessagesDb,
          ...formatUnattendedMessages,
        ].sort(function (a, b) {
          return Number(a.message_id) - Number(b.message_id);
        });

        if (job.attendanceType != 'MANUAL' && searchLastMessageDb) {
          job.messages = [...formatedMessages, ...messagesInOrder];
        } else {
          job.messages = [...formatedMessages, ...messagesInOrder];
        }

        commit(DELETE_UNATTENDED_MESSAGES, job.protocol);
      } else {
        formatedMessagesDb = formatMessagesJob(
          historyMessagesDb,
          job,
          agentId,
          true,
        );
        if (job.attendanceType != 'MANUAL') {
          job.messages = [...formatedMessagesDb];
        } else {
          job.messages = [];
        }
      }

      job.timestampLastMessage = 0;
      if (formatedMessagesDb.length > 0 && job.attendanceType != 'MANUAL') {
        let auxjobMessages = [...formatedMessagesDb];
        let foundMessageDB = false;

        for (let msg of auxjobMessages.reverse()) {
          if (msg.type == 'receipt') {
            foundMessageDB = true;
            let datum = Date.parse(msg.time);
            job.timestampLastMessage = datum / 1000;
            break;
          }
        }

        if (!foundMessageDB) {
          if (job.messages) {
            let auxjobMessages = [...job.messages];
            for (let msg of auxjobMessages.reverse()) {
              if (msg.type == 'receipt') {
                console.log('msg ELASTIC !foundMessageDB', msg);
                let datum = Date.parse(msg.time);
                job.timestampLastMessage = datum / 1000;
                break;
              }
            }
          }
        }
      } else {
        if (job.messages) {
          let auxjobMessages = [...job.messages];
          for (let msg of auxjobMessages.reverse()) {
            if (msg.type == 'receipt') {
              console.log('msg ELASTIC job.messages', msg);
              console.log('receipt janela', msg);
              let datum = Date.parse(msg.time);
              job.timestampLastMessage = datum / 1000;
              break;
            }
          }
        }
      }

      let now = new Date().getTime() / 1000;

      job.startConversation = true;
      job.waitingAnswer = false;

      job.error = false;

      let goToValidation24h = false;

      if (route.data && route.data[0].api_oficial == 'N') {
        goToValidation24h = false;
      } else {
        if (now > job.timestampLastMessage + 86400) {
          goToValidation24h = true;
        } else {
          if (
            (job.attendanceType == 'MANUAL' &&
              job.inboxRemovedByAgent &&
              job.protocolInbox) ||
            (job.attendanceType == 'MANUAL' &&
              job.inboxRemovedByAgent &&
              !job.protocolInbox) ||
            (job.attendanceType == 'MANUAL' &&
              !job.inboxRemovedByAgent &&
              !job.protocolInbox) ||
            (job.attendanceType == 'QUEUE' &&
              job.inboxRemovedByAgent &&
              job.protocolInbox) ||
            (job.attendanceType == 'QUEUE' &&
              job.inboxRemovedByAgent &&
              !job.protocolInbox)
          ) {
            goToValidation24h = true;
          } else {
            goToValidation24h = false;
          }
        }
      }

      if (job.metaType === 'instagram') {
        goToValidation24h = true;
      }

      if (goToValidation24h) {
        if (now > job.timestampLastMessage + 86400) {
          if (job.metaType === 'instagram') {
            job.startConversation = true;
            job.waitingAnswer = true;
            job.allowConversationWithoutTemplate = false;
          } else if (
            (route.data && route.data[0].api == 'twilio') ||
            (route.data && route.data[0].api == 'zenvia') ||
            (route.data && route.data[0].api == 'infobip') ||
            (route.data && route.data[0].api == 'gupshup')
          ) {
            job.startConversation = true;
            job.waitingAnswer = true;
          } else {
            job.startConversation = false;
            job.waitingAnswer = false;
            job.allowConversationWithoutTemplate = true;
          }
        } else {
          job.waitingAnswer = false;
          job.startConversation = false;
          job.allowConversationWithoutTemplate = true;
        }
      } else {
        job.waitingAnswer = false;
        job.startConversation = false;
        job.allowConversationWithoutTemplate = true;
      }

      if (job.startConversation) {
        // dispatch('disableConversationTab')
        dispatch('disableConversationOptions');
      } else {
        dispatch('enableConversationOptions');
      }

      if (job.messages) {
        let auxjobMessages = [...job.messages];
        for (let msg of auxjobMessages.reverse()) {
          if (msg.constructor.name == 'Object') {
            if (msg.type == 'text') {
              job.notifications = job.notifications + 1;
            }
          } else {
            break;
          }
        }
      }

      job.messages.sort((a, b) => new Date(a.time) - new Date(b.time));

      const lastMess = job.messages[job.messages.length - 1];
      if (!lastMess) {
        job.lastMessage = '';
      } else {
        try {
          job.lastMessage = `${JSON.parse(lastMess.message)}` || '';
        } catch (error) {
          job.lastMessage = `${lastMess.message}` || '';
        }
      }

      const contacts = job?.contact;

      if (contacts && Array.isArray(contacts) && contacts.length === 0) {
        job.contact = {
          lastContact: null,
        };
      }

      // Ao clicar no job e para marcar como lido, o agentUnreadMessages é 0
      // e o notifications é 0, então é necessário atualizar o job com o valor de unread
      const unread = !!job.agentUnreadMessages;
      job.mounted = true;
      job.unread = unread;
      job.agentUnreadMessages = 0;
      job.notifications = 0;

      commit(ADD_ATTENDANCE_JOB, job);

      dispatch('setWhatsappRead', {
        agent_id: job.agentId,
        protocol: job.protocol,
        unread,
        handleJobClick: true,
      });

      if (!job.closedWithoutQualify) {
        if (
          rootState.channel.channels.whatsapp.status == 'paused' ||
          rootState.channel.channels.whatsapp.status == 'scheduled_pause'
        ) {
          dispatch('channel/updateStatusWhatsApp', 'scheduled_pause', {
            root: true,
          });
        } else {
          dispatch('channel/updateStatusWhatsApp', 'in_attendance', {
            root: true,
          });
        }
      }

      dispatch('addHistoryMessages', {
        messages: null,
        protocol: job.protocol,
      });

      if (!job.hasOwnProperty('protocolInbox') && !hasProtocolAttendance) {
        dispatch('navigation', job);
      }

      if (
        job.hasOwnProperty('protocolInbox') &&
        job.inboxRemovedByAgent &&
        !hasProtocolAttendance
      ) {
        dispatch('navigation', job);
      }
    } catch (err) {
      window.console.error(err);
      dispatch(
        'showSnackbar',
        {
          text: 'Ocorreu um erro ao recuperar os dados do contato',
          type: 'error',
        },
        { root: true },
      );
    }
  },

  endWhatsApp({ dispatch }, { informations, protocol }) {
    return JobService.finish(informations)
      .then(() => dispatch('disableJob', protocol))
      .catch((err) => {
        console.log(err);
        dispatch(
          'showSnackbar',
          {
            text: err.response.data.cause,
            type: 'error',
          },
          { root: true },
        );
      });
  },

  whatsappTransfer({ dispatch }, informations) {
    return new Promise((resolve, reject) => {
      whatsappTransfer(informations)
        .then(() => {
          dispatch(
            'showSnackbar',
            { text: 'Transferência realizada com sucesso', type: 'success' },
            { root: true },
          );
          resolve();
        })
        .catch((err) => {
          let errorMessage = 'Não foi possível realizar a transferência';
          if (err.response.data.cause == 'offline') {
            errorMessage = 'cannotTransferBecauseAgentOffline';
          }
          if (err.response.data.cause == 'queue') {
            errorMessage = 'cannotTransferBecauseAgentNotInQueue';
          }
          if (err.response.data.cause == 'pause') {
            errorMessage = 'cannotTransferBecauseAgentInPause';
          }
          dispatch(
            'showSnackbar',
            { text: errorMessage, type: 'error' },
            { root: true },
          );
          reject(err.message);
        });
    });
  },

  activeJobWhatsApp(
    { dispatch, commit, rootState },
    {
      whatsappIdentifier,
      whatsAppCampaign,
      whatsAppRoute,
      agentId,
      whatsAppCampaignName,
      contactId,
      contactIdentifier,
    },
  ) {
    const informations = {
      whatsapp: whatsappIdentifier,
      agent_id: agentId,
      campaign_id: whatsAppCampaign,
      route: whatsAppRoute,
      campaign_name: whatsAppCampaignName,
      contact_id: contactId,
      contact_identifier: contactIdentifier,
    };
    activeJobWhatsapp(informations)
      .then(() => {
        EventBus.$emit('load-templates-twilio');
        commit(NEW_MANUAL_ACTIVATION, informations);
        dispatch(
          'showSnackbar',
          { text: 'triggerActiveJobSuccess', type: 'success', history: true },
          { root: true },
        );
      })
      .catch((err) => {
        const {
          response: { data, status },
        } = err;

        let groupName = '';
        let agentName = '';
        let agentId = '';

        if (data.hasOwnProperty('queue_name')) {
          groupName = rootState.attendanceGroups.groupList.find(
            (group) => group.queue_whatsapp_context == data.queue_name,
          ).name;
        }
        if (data.hasOwnProperty('agent_name')) {
          agentName = data.agent_name;
        }
        if (data.hasOwnProperty('agent_id')) {
          agentId = data.agent_id;
        }

        if (status === 401 && data.cause === 'clientOnBot') {
          dispatch(
            'showSnackbar',
            { text: 'clientOnBot', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (status === 401 && data.reason === 'agentWhatsappOffline') {
          dispatch(
            'showSnackbar',
            {
              text: 'agentWhatsappOffline',
              type: 'error',
              replaces: { agentId: data.agent_id, agentName: data.agent_name },
              history: true,
            },
            { root: true },
          );
          return;
        }

        if (
          data.reason == 'alreadyInAttendance' ||
          data.reason == 'alreadyInInbox' ||
          data.reason == 'alreadyPreferential' ||
          data.reason == 'evaluation'
        ) {
          dispatch(
            'showSnackbar',
            {
              text: data.reason,
              replaces: { agentId: data.agent_id, agentName: data.agent_name },
              history: true,
            },
            { root: true },
          );
          return;
        }

        if (data.cause == 'blacklist') {
          dispatch(
            'showSnackbar',
            { text: 'contactInBlacklist', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.reason == 'clientOnHold') {
          if (agentId != '' && agentName != '') {
            dispatch(
              'showSnackbar',
              {
                text: data.reason + 'Preferential',
                type: 'error',
                replaces: { agentName },
                history: true,
              },
              { root: true },
            );
            return;
          }

          dispatch(
            'showSnackbar',
            {
              text: data.reason,
              type: 'error',
              replaces: {
                queueName: groupName,
                queuePosition: data.queue_position,
              },
              history: true,
            },
            { root: true },
          );
          return;
        }

        if (data.cause == 'limitQueue') {
          dispatch(
            'showSnackbar',
            { text: 'limitQueue', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.cause == 'limitGlobal') {
          dispatch(
            'showSnackbar',
            { text: 'limitGlobal', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.reason == 'clientOnBot') {
          dispatch(
            'showSnackbar',
            { text: 'clientOnBot', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.reason == 'agentNotInCampaign') {
          dispatch(
            'showSnackbar',
            { text: 'agentNotInCampaign', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.cause == 'evaluation') {
          dispatch(
            'showSnackbar',
            { text: 'evaluation', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (data.cause === 'agentWhatsappOffline') {
          dispatch(
            'showSnackbar',
            { text: 'agentWhatsappOffline', type: 'error', history: true },
            { root: true },
          );
          return;
        }

        if (err.response.status == 500) {
          dispatch(
            'showSnackbar',
            {
              text: 'Erro ao iniciar atendimento com o contato',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .catch(handleError);
  },

  whatsappQualify({ dispatch }, informations) {
    return new Promise((resolve, reject) => {
      whatsappQualify(informations)
        .then(() => {
          if (!informations.inbox)
            dispatch(
              'showSnackbar',
              { text: 'qualificationSuccess', type: 'success' },
              { root: true },
            );
          resolve(true);
        })
        .catch(() => {
          if (!informations.inbox)
            dispatch(
              'showSnackbar',
              {
                text: 'Não foi possível realizar a qualificação.',
                type: 'error',
              },
              { root: true },
            );
          reject(true);
        });
    });
  },

  updateAgentStatusWhatsApp({ dispatch, rootState }) {
    const { agentId } = rootState.attendance.Attendance;
    dispatch('attendance/getStatusAgent', agentId, { root: true });
  },
  async whatsappReopen(
    { dispatch, rootState },
    { protocol, agent_id, silent },
  ) {
    const { inboxJobs } = rootState.jobs;
    const jobFound = inboxJobs.find((job) => job.protocol == protocol);

    if (jobFound != undefined) {
      return await whatsappReopen({ protocol, agent_id })
        .then((res) => {
          if (!silent) {
            dispatch('removeInboxInProccess', protocol);
            dispatch(
              'showSnackbar',
              { text: 'thisJobWillReopen' },
              { root: true },
            );
          } else {
            dispatch('removeInboxInProccess', protocol);
            dispatch('cleanProtocolBackup', protocol);
            console.log(
              '[WEON][REOPEN][JOB][SUCCESS] - Protocol: [' +
                protocol +
                '] com sucesso!',
            );
          }
        })
        .catch((err) => {
          if (!silent) {
            const cause = err.response.data.cause;
            dispatch(
              'showSnackbar',
              { text: cause, type: 'error' },
              { root: true },
            );
          } else {
            console.log(
              '[WEON][REOPEN][JOB][ERROR] - Problema ao reabrir Protocol: [' +
                protocol +
                ']!',
            );
          }
        });
    }
  },
  saveUnattendedMessage({ commit }, { message, protocol }) {
    commit(SAVE_UNATTENDED_MESSAGE, { message, protocol });
  },

  whatsappNumberNotExists({ commit, dispatch }, { protocol, number }) {
    commit(WHATSAPP_NUMBER_NOT_EXISTS, protocol);
    dispatch(
      'showSnackbar',
      {
        text: 'theNumberDoesNotHaveWhatsapp',
        type: 'error',
        replaces: { number },
      },
      { root: true },
    );
  },

  async readAllMessages({ dispatch, rootState, commit }, protocol) {
    try {
      const agentId = rootState.attendance.Attendance.agentId;
      await JobService.readAllMessages(agentId, protocol);
      commit('RESET_AGENT_UNREAD_MESSAGES', protocol);
    } catch (error) {
      //
    }
  },
  async getWhatsAppMessageById(
    { commit },
    { protocol, messageId, messageAnsweredId },
  ) {
    await getMessageById(messageAnsweredId)
      .then((response) => {
        commit('ADD_MESSAGE_ANSWERED', {
          protocol,
          messageId,
          messageAnswered: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async sendWhatsAppVoiceCallPermission({ dispatch }, informations) {
    await sendWhatsAppVoiceCallPermission(informations);
  },
};

export default actions;
